<template>
  <div class="item-step">
    <div class="left-shape">
      <i class="dot"></i>
      <div v-if="!isFinished" class="line"></div>
    </div>
    <div class="right-main">
      <div class="mb-4">
        <label v-if="isRequired" class="text-danger text-medium align-top">*</label>
        <span class="opacity-85 text-medium text-black">{{ title }}</span>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isFinished: {
      type: Boolean,
      default: false
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.item-step {
  padding-bottom: 60px;
  @apply flex relative;
  .left-shape {
    width: 17px;
    @apply absolute h-full;
    .dot {
      width: 9px;
      height: 9px;
      border-radius: 50%;
      @apply inline-block bg-theme;
    }
    .line {
      width: 1px;
      margin-top: -9px;
      margin-left: 4px;
      @apply h-full bg-theme;
    }
  }
  .right-main {
    margin-left: 17px;
    @apply w-full flex flex-col;
  }
}
</style>
